import React from "react";
import { Checkbox } from "@episerver/ui-framework";

export const CCCheckbox = (props: any) => {
    const { readOnly, onChange, ...rest } = props;
    const newOnChange = (e: any) => {
        if(!readOnly)
            onChange(e);
    }
    return <Checkbox {...rest} readOnly={readOnly} onChange={newOnChange} />;
};